import React, { Component } from "react";
import { connect } from "react-redux";
import { Tabs, Alert, message } from "antd";
import {
  req_list_cslc_public_lottery,
  req_list_csll_lottery,
  req_add_csll_lottery,
  req_downloadfile_csll_lottery,
} from "../../api";
import storageUtils from "../../utils/storageUtils";
import { API_BASE } from "../../utils/contrains";
import { Table } from "antd";

class ManagerLotteryList extends Component {
  state = {
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    gameAStatus: "OPEN",
    gameBStatus: "OPEN",
    gameAItems: [],
    gameBItems: [],
    nowGameName: "伯樂獎",
    nowGameCode: "STANDARD",
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_check_lottery("伯樂獎");
    this.api_check_lottery("慧眼獨具獎");
  }

  // 遠端數據處理 //////////////////////////////////////////////

  // 1.確認是否已經開獎了
  api_check_lottery = async (prizeName) => {
    // var userLevel = usrRole(role);
    // this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const game = await req_list_cslc_public_lottery(prizeName);
    const status = game.total === 0 ? "OPEN" : "CLOSE";
    prizeName === "伯樂獎"
      ? this.setState({ gameAStatus: status })
      : this.setState({ gameBStatus: status });
    this.setState({ loading: false });
  };

  // 2.隨機抽獎
  api_list_items = async (prizeCode) => {
    this.setState({ loading: true });
    const result = await req_list_csll_lottery(
      prizeCode,
      storageUtils.getUser().token
    );
    this.setState({ loading: false });

    //console.log(result)
    if (result.total > 0) {
      const { data } = result;
      const items = data;
      prizeCode === "STANDARD"
        ? this.setState({ gameAItems: items })
        : this.setState({ gameBItems: items });
      //console.log(items);
    } else {
      const items = [];
      prizeCode === "STANDARD"
        ? this.setState({ gameAItems: items })
        : this.setState({ gameBItems: items });
    }
  };

  //3.儲存結果，並關閉抽獎，開啟下載清單
  api_save_items = (prizeName, items) => {
    // if (items.length < 4) {
    for (var idx = 0; idx < items.length; idx++) {
      req_add_csll_lottery(items[idx], storageUtils.getUser().token);
      if (idx === items.length - 1) {
        prizeName === "伯樂獎"
          ? this.setState({ gameAStatus: "CLOSE", gameAItems: [] })
          : this.setState({ gameBStatus: "CLOSE", gameBItems: [] });
        message.info("中獎名冊已送出");
      }
    }
    // }
  };

  api_downloadfile_items = async () => {
    const { token } = this.props.user;
    const { nowGameName } = this.state;
    const fileUrl = await req_downloadfile_csll_lottery(nowGameName, token);

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "獲獎清單";
    a.click();
  };

  // 數據配置設定 //////////////////////////////////////////////
  init_columns = () => {
    this.columns = [
      {
        title: "獎項名稱",
        dataIndex: "PrizeName",
        width: 30,
      },
      {
        title: "中獎人編號",
        dataIndex: "WinnerId",
        width: 20,
        responsive: ["md"],
      },
      {
        title: "中獎人姓名",
        dataIndex: "WinnerName",
        width: 30,
      },
      {
        title: "中獎人部門",
        dataIndex: "WinnerDepartment",
        width: 40,
        responsive: ["md"],
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////
  handle_data_refresh = () => {
    this.api_check_voted();
  };

  handle_save_data = () => {
    const { nowGameName, gameAItems, gameBItems } = this.state;
    const items = nowGameName === "伯樂獎" ? gameAItems : gameBItems;
    this.api_save_items(nowGameName, items);
    console.log(nowGameName);
  };

  handle_ui_modal = () => {
    const { nowGameCode } = this.state;
    //console.log(nowGameCode);
    this.api_list_items(nowGameCode);
  };

  handle_tab_change = (key) => {
    console.log(key);
    var prizeName = "";
    var prizeCode = "";
    switch (key) {
      case "1":
        prizeName = "伯樂獎";
        prizeCode = "STANDARD";
        this.setState(
          { nowGameName: prizeName, nowGameCode: prizeCode },
          () => {
            // console.log(this.state);
          }
        );

        break;
      case "2":
        prizeName = "慧眼獨具獎";
        prizeCode = "RANK";
        this.setState(
          { nowGameName: prizeName, nowGameCode: prizeCode },
          () => {
            // console.log(this.state);
          }
        );
        break;
      default:
    }
  };

  /////////////////////////////////////////////////////////////
  render() {
    const { gameAItems, gameBItems, gameAStatus, gameBStatus } = this.state;
    //console.log(gameAStatus);
    return (
      <>
        <Tabs
          defaultActiveKey="1"
          onChange={this.handle_tab_change}
          type="card"
        >
          <Tabs.TabPane tab="伯樂獎(共50名)" key="1">
            <Alert
              message="從所有參與票選人中抽出50名，每人可獲得100元禮券。(每人限得獎一次)"
              type="info"
            />
            <button
              className="btn btn-warning"
              style={{ margin: "4px" }}
              onClick={() => this.handle_ui_modal()}
              disabled={gameAStatus === "CLOSE" ? true : false}
            >
              [伯樂獎]抽獎
            </button>
            <button
              className="btn btn-success"
              style={{ margin: "4px" }}
              onClick={() => this.handle_save_data()}
              disabled={gameAItems.length === 0 ? true : false}
            >
              開獎結果存檔
            </button>
            <button
              className="btn btn-primary"
              style={{ margin: "4px" }}
              onClick={() => this.api_downloadfile_items()}
              disabled={gameAStatus === "OPEN" ? true : false}
            >
              下載中獎人名冊
            </button>
            <Table
              bordered
              scroll={{ y: 480 }}
              rowKey="WinnerId"
              dataSource={gameAItems}
              //  onChange={this.handle_table_change}
              pagination={false}
              columns={this.columns}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab="慧眼獨具獎(共5名)" key="2">
            <Alert
              message="投票作品進入第一名者，另抽出5名獲得300元禮券。(每人限得獎一次，但不包括已獲得伯樂獎者)"
              type="info"
            />
            <button
              className="btn btn-warning"
              style={{ margin: "4px" }}
              onClick={() => this.handle_ui_modal()}
              disabled={gameBStatus === "CLOSE" ? true : false}
            >
              [慧眼獨具獎]抽獎
            </button>
            <button
              className="btn btn-success"
              style={{ margin: "4px" }}
              onClick={() => this.handle_save_data()}
              disabled={gameBItems.length === 0 ? true : false}
            >
              開獎結果存檔
            </button>
            <button
              className="btn btn-primary"
              style={{ margin: "4px" }}
              onClick={() => this.api_downloadfile_items()}
              disabled={gameBStatus === "OPEN" ? true : false}
            >
              下載中獎人名冊
            </button>
            <Table
              bordered
              scroll={{ y: 480 }}
              rowKey="WinnerId"
              dataSource={gameBItems}
              onChange={this.handle_ui_modal}
              pagination={false}
              columns={this.columns}
            />
          </Tabs.TabPane>
        </Tabs>
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(ManagerLotteryList);
